var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{attrs:{"value":_vm.value,"sync":true,"color":{ checked: '#0ea895', unchecked: '#d9dfe3' },"width":56,"height":31},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }